export const useDecimaleEscapeFormatter = () => {
  const encode = (string) => {
    return Array.from(new TextEncoder().encode(string))
      .map(byte => byte < 128 ? String.fromCharCode(byte) : `\\${byte}`)
      .join('')
  }

  const decode = (escapedString) => {
    const bytes = []
    let i = 0

    while (i < escapedString.length) {
      const currentChar = escapedString[i]

      // Если нашли обратный слеш и после него цифры - это escape-последовательность
      if (currentChar === '\\' && i + 1 < escapedString.length) {
        // Ищем последовательность цифр после обратного слеша
        let numStr = ''
        let j = i + 1

        // Собираем все цифры подряд (максимум 3, так как байт 0-255)
        while (j < escapedString.length && /\d/.test(escapedString[j]) && numStr.length < 3) {
          numStr += escapedString[j]
          j++
        }

        // Если нашли цифры, преобразуем в байт
        if (numStr) {
          const byteValue = parseInt(numStr, 10)
          // Проверяем, что значение в диапазоне байта (0-255)
          if (byteValue >= 0 && byteValue <= 255) {
            bytes.push(byteValue)
            i = j // Перемещаем индекс на позицию после цифр
            continue
          }
        }
      }

      // Если это не escape-последовательность, добавляем ASCII-код символа
      bytes.push(escapedString.charCodeAt(i))
      i++
    }

    return new TextDecoder().decode(new Uint8Array(bytes))
  }

  return {
    encode,
    decode
  }
}
